import { getData } from '../utils/HelperFunctions.js';

export const getFeatures = async (paramsObject = {}) => {
    try {
        const response = await getData(paramsObject, 'v1/features');
        return response;
    } catch (error) {
        console.error('Error fetching features:', error);
        throw error;
    }
};
